export const NO_DELIVERY_AND_COLLECTION =
  'waitrose/registration/NO_AVAILABLE_DELIVERY_AND_COLLECTION';
export const COLLECTION = 'waitrose/registration/AVAILABLE_COLLECTION';
export const DELIVERY = 'waitrose/registration/AVAILABLE_DELIVERY';
